import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { getIssuesComponent, getErrorIssues, getWarningIssues } from '../../../../../../../utils/validationSummary';

class PropertyTableD2WPicker extends React.Component {

    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
    }

    isOn(property) {
        return property.value !== undefined
            && property.value !== null
            && property.value !== ''
            && property.value.toUpperCase() !== 'OFF'
            && property.value !== property.valueMeta.off;
    }

    handleChange(e) {

        e.preventDefault();

        let value = e.target.value;
        const name = e.target.name;

        // It is 1-based
        const index = parseInt(name.replace("dw.l", '').replace("dw.c", ''));
        const type = name.replace(index, '');

        // if I am deleting
        if (value === null || value === '') {
            if (index === 0 || index === 1) {
                return;
            }

            // Maybe we have to move
            for (let i = index; i < 3; i++) {
                this.props.handleChange(`dw.c${(i)}`, this.props.properties[`dw.c${i + 1}`].value);
                this.props.handleChange(`dw.l${(i)}`, this.props.properties[`dw.l${i + 1}`].value);
            }

            this.props.handleChange(`dw.c${(3)}`, 'Off');
            this.props.handleChange(`dw.l${(3)}`, 'Off');

            return;
        }

        //If I am adding
        if (type === 'dw.c' && !this.isOn(this.props.properties[`dw.c${index}`])) {
            if (!this.isOn(this.props.properties[`dw.l${index}`])) {
                this.props.handleChange(`dw.l${index}`, this.props.properties[`dw.l${index - 1}`].value)
            }
        }
        this.props.handleChange(name, value);
    }

    renderPropertiesRow(type) {

        return Object.keys(this.props.properties).sort().map((key) => {

            if (this.props.properties[key].info.name.includes(type)) {

                const errors = getErrorIssues(this.props.issues, this.props.properties[key]);
                const warnings = getWarningIssues(this.props.issues, this.props.properties[key]);

                const className = `input-property-picker ${errors.length > 0 ? 'danger' : warnings.length > 0 ? 'warning' : ''}`;

                // It is 1-based
                const index = parseInt(key.replace("dw.l", '').replace("dw.c", ''));
                const type = key.replace(index, '');

                // Only for Custom
                if (this.props.properties[key].info.name === "dw.l0") {
                    return (
                        <Col sm={this.props.sizePickers} style={{ padding: '0' }} key={this.props.properties[key].id}>
                            <input
                                id={key}
                                disabled
                                className={className}
                                name={this.props.properties[key].info.name}
                                type="number"
                                min={this.props.properties[key].valueMeta.min}
                                max={this.props.properties[key].valueMeta.max}
                                value={this.props.properties[key].value}
                                onChange={this.handleChange} />
                        </Col>
                    );
                }

                return (
                    <Col sm={this.props.sizePickers} style={{ padding: '0' }} key={this.props.properties[key].id}>
                        <input
                            id={key}
                            disabled={this.props.disabled ||
                                (index > 1 && (this.props.properties[`${type}${index - 1}`].value === 'Off' ||
                                    this.props.properties[`${type}${index - 1}`].value === this.props.properties[`${type}${index - 1}`].valueMeta.off)) ||
                                type === 'dw.l' && this.props.properties[`dw.c${index}`].value == 'Off'
                            }
                            className={className}
                            name={this.props.properties[key].info.name}
                            type="number"
                            min={this.props.properties[key].valueMeta.min}
                            max={this.props.properties[key].valueMeta.max}
                            value={this.getValue(this.props.properties[key])}
                            onChange={this.handleChange} />
                        {getIssuesComponent(errors, warnings)}
                    </Col>
                );

            }
            return null;
        });
    }

    getValue(property) {

        // Only for Custom
        if (property.info.name === "dw.l0") {
            if (property.value === "Off") {
                return "100";
            }
            return property.value;
        }

        if (property.value !== property.valueMeta.off) {
            return property.value;
        } else if (property.value === "Off") {
            return "";
        }
        return "";
    }

    render() {
        return (
            <div>
                <Row>
                    <Col sm={this.props.sizeTitle} style={{ paddingRight: '0.5rem' }}>
                        {this.props.firstRow.title}
                    </Col>
                    {this.renderPropertiesRow(this.props.firstRow.property)}
                    <Col sm={1} style={{ paddingLeft: '0.5rem' }}>
                        {this.props.firstRow.measureUnit}
                    </Col>
                </Row>
                <Row>
                    <Col sm={this.props.sizeTitle} style={{ paddingRight: '0.5rem' }}>
                        {this.props.secondRow.title}
                    </Col>
                    {this.renderPropertiesRow(this.props.secondRow.property)}
                    <Col sm={this.props.sizeMeasureUnit} style={{ paddingLeft: '0.5rem' }}>
                        {this.props.secondRow.measureUnit}
                    </Col>
                </Row>
            </div>
        );
    };
}

const mapStateToProps = (state, ownProps) => {
    return {
        validationSummary: state.project.validationSummary,
        issues: state.project.issueByProperty,
    };
};

const mapDispatchToProps = {
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PropertyTableD2WPicker);
